import { jsx as _jsx } from "react/jsx-runtime";
export function Pill({ variant = 'neutral', children, className }) {
    return (_jsx("span", { className: `pill pill--${variant}${className ? ` ${className}` : ''}`, children: children }));
}
//# sourceMappingURL=Pill.js.map